export default "__VITE_ASSET__DNHMOMWl__"